export default __webpack_public_path__ + "static/media/gardenpoundsign.5f0e2491.jpg";